<template>
  <div>
    <div class="mail-box-header">
      <form v-on:submit.prevent="relateVehicle()">
        <div class="row">
          <div class="col-lg-4">
            <div class="input-group col-lg-12">
              <input
                type="text"
                class="form-control"
                placeholder="Digite a placa"
                v-model="licencePlate"
                @blur="searchVehicle"
              />
            </div>
          </div>
          <div class="col-lg-4">
            <div class="input-group col-lg-12">
              <input
                type="text"
                class="form-control"
                placeholder="Tolerancia"
                v-model="continuousTolerance"
              />
            </div>
          </div>
          <div class="input-group-btn col-lg-4">
            <button
              type="submit"
              class="btn btn-sm btn-primary"
              :disabled="!selectedSchedule"
            >
              <i class="fa fa-send"></i>
              Salvar
            </button>
          </div>
        </div>
      </form>
      <br />
      <div v-if="hasVehicle">
        <h4 class="info-text">
          O veículo {{ vehicle.licencePlate.toUpperCase()
          }}<span>{{
            isRelated ? ' está relacionado' : ' NÃO está relacionado'
          }}</span>
          com a agenda selecionada.
        </h4>
      </div>

      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Placa</th>
            <th>
              relacionado<br />
              com agenda
            </th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(vehicle, key) in vehicles" :key="key">
            <td>{{ vehicle.licencePlate }}</td>

            <td @click.prevent="relateVehicle(vehicle.licencePlate)">
              <switches
                v-model="vehicle.tariffSchedule"
                theme="bootstrap"
                color="success"
                :emit-on-mount="false"
              ></switches>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Switches from 'vue-switches';
export default {
  components: {
    Switches,
  },
  props: {
    selectedSchedule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      licencePlate: '',
      continuousTolerance: undefined,
      vehicle: '',
      hasVehicle: false,
      vehicles: [],
    };
  },
  computed: {
    isRelated() {
      return (
        String(this.vehicle.tariffSchedule) === String(this.selectedSchedule)
      );
    },
  },
  mounted() {
    this.getAllBySchedule();
  },
  watch: {
    selectedSchedule() {
      this.getAllBySchedule();
    },
  },

  methods: {
    async searchVehicle() {
      try {
        const vehicle = await this.$store.dispatch(
          'VEHICLE/GetByLicencePlate',
          {
            licencePlate: this.licencePlate,
          },
        );

        this.vehicle = vehicle;
        this.hasVehicle = true;
      } catch (error) {
        this.$toasted.error('Não foi possível listar veículo');
      }
    },
    async getAllBySchedule() {
      if (!this.selectedSchedule) {
        return;
      }
      try {
        const vehicles = await this.$store.dispatch(
          'VEHICLE/GetVehicleByShedule',
          {
            scheduleId: this.selectedSchedule,
          },
        );

        this.vehicles = vehicles;
      } catch (error) {
        this.$toasted.error('Não foi possível listar veículo');
      }
    },
    async relateVehicle(licencePlate = '') {
      try {
        const payload = {
          tariffScheduleId: this.selectedSchedule,
          licencePlate: licencePlate ? licencePlate : this.licencePlate,
          continuousTolerance: this.continuousTolerance || null,
        };

        await this.$store.dispatch('RELATE/RelateVehicle', payload);
        await this.searchVehicle();
        await this.getAllBySchedule();
        this.$toasted.success('Veículo relacionado com sucesso!');
      } catch (error) {
        this.$toasted.error('Não foi possível relacionar veículo');
      }
    },
  },
};
</script>